import React from 'react';
import { ButtonPopup } from '../ui';
import { useNavigate } from 'react-router-dom'; // 👈 Importante
import { motion } from 'framer-motion';

interface PaginaCookieRechazadaProps {
  onReconsider?: () => void; // opcional
}

const PaginaCookieRechazada: React.FC<PaginaCookieRechazadaProps> = ({ onReconsider }) => {
  const navigate = useNavigate();

  const cerrarVentana = () => {
    navigate('/cookies-bloqueadas');
  };

  const volverADecidir = () => {
    if (onReconsider) {
      onReconsider();
    } else {
      navigate('/cookieConsentModal');
    }
  };

 return (
  <div
    className="flex items-center justify-center w-screen h-screen text-center px-6 bg-cover bg-center relative"
    style={{ backgroundImage: "url('/img/politicas/cookies.png')" }}
  >    {/* overlay oscuro para legibilidad */}
    <div className="absolute inset-0 bg-black/30 backdrop-blur-sm" />

    <motion.div
      initial={{ opacity: 0, y:20, scale: 0.65 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 1 }}
      className="relative z-10 max-w-md w-full"
    >
      <div className="p-8 rounded-2xl border border-white/20 shadow-2xl bg-transparent/5 backdrop-blur-5xl">
        
        <h1 className="text-2xl font-bold mb-4 text-white">
          Has rechazado el uso de cookies
        </h1>

        <p className="mb-6 text-white/80">
          Para poder continuar usando este sitio, necesitamos tu consentimiento para usar cookies esenciales.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 w-full justify-center">
          <ButtonPopup
            onClick={volverADecidir}
            className="min-w-[12rem] text-lg w-full sm:w-auto bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition shadow-md"
          >
            Volver a decidir
          </ButtonPopup>

          <ButtonPopup
            onClick={cerrarVentana}
            className="min-w-[12rem] text-lg w-full sm:w-auto bg-red-600 text-white rounded-lg hover:bg-red-700 transition shadow-md"
          >
            Cerrar ventana
          </ButtonPopup>
        </div>

      </div>
    </motion.div>
  </div>
);

};


export default PaginaCookieRechazada;
